import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Importer des fiches")
], -1)
const _hoisted_2 = { class: "form-content flex-grow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Toutes les fiches seront créées ainsi que toutes les entités liées (chien, tir, demandeur, ...). "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, " Si une fiche existe déjà dans la base, l'ancienne version est conservée et la nouvelle ignorée. ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "text-success"
}
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "import-file-input" }, "Fichier à uploader", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Import en cours ...", -1)
const _hoisted_9 = ["max", "value"]
const _hoisted_10 = {
  key: 1,
  class: "form-footer"
}
const _hoisted_11 = ["disabled"]

import { request } from "@/domains/api/api";
import FileUploader from "@/domains/app/components/FileUploader.vue";
import { UploadedFile } from "@/domains/app/forms";
import { onUnmounted, ref } from "vue";
import { io } from "socket.io-client";
import { useMetaTitle } from "@/domains/app/pageMeta";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const error = ref("");
const message = ref("");
const importJob = ref<null | { totalJobCount: number; current: number }>(null);

useMetaTitle().setTitle("Import");

const socket = io(process.env.VUE_APP_WS_SERVER_URL || "ws://test.domain/");
socket.on("import.new", (e) => {
    importJob.value = e.data;
    if (
        importJob.value &&
        importJob.value.current === importJob.value.totalJobCount
    ) {
        message.value = "Import terminé";
    }
});
socket.on("import.error", (e) => {
    error.value = e.data.message || "Une erreur est survenue";
});

onUnmounted(() => {
    socket.disconnect();
});

const fileToImport = ref<UploadedFile>();

function importData() {
    error.value = "";
    message.value = "";
    if (!fileToImport.value) return;

    return request("import", "post", (e) => (error.value = e.message), {
        file: fileToImport.value.filePath,
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (importData()), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (message.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(message.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(FileUploader, {
          id: "import-file-input",
          file: fileToImport.value,
          "onUpdate:file": _cache[0] || (_cache[0] = ($event: any) => ((fileToImport).value = $event)),
          title: "Fichier d'import"
        }, null, 8, ["file"])
      ])
    ]),
    (
                importJob.value?.totalJobCount !== undefined &&
                importJob.value?.current !== undefined
            )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_8,
          _createElementVNode("progress", {
            max: importJob.value.totalJobCount,
            value: importJob.value.current
          }, _toDisplayString((importJob.value.current / importJob.value.totalJobCount) * 100), 9, _hoisted_9)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: !fileToImport.value
          }, " Importer les fiches ", 8, _hoisted_11)
        ]))
  ], 32))
}
}

})